const onEnter =
  (handler) =>
  (e, ...args) => {
    if (e.key === 'Enter') {
      handler(e, ...args);
    }
  };

export default onEnter;
